import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=061cd9d0&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=ts&"
export * from "./Statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061cd9d0",
  null
  
)

export default component.exports